const MFA_ENROLLMENT_ACCOUNT_KEY = 'h3ight_mfa_enrollment_account';

export function getMFAEnrollmentAccount(): string | null {
  try {
    return window.sessionStorage.getItem(MFA_ENROLLMENT_ACCOUNT_KEY);
  } catch {
    return null;
  }
}

export function setMFAEnrollmentAccount(account: string): void {
  try {
    window.sessionStorage.setItem(MFA_ENROLLMENT_ACCOUNT_KEY, account);
  } catch {
    return;
  }
}

export function clearMFAEnrollmentAccount(): void {
  try {
    window.sessionStorage.removeItem(MFA_ENROLLMENT_ACCOUNT_KEY);
  } catch {
    return;
  }
}
